import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';
import testimonies from '../data/testimonies';

const Testimonies = () => {
  return (
    <>
      <SEOHead path="/testimonies" />
      <PageHeader title="Testimonies" breadcrumb="Testimony" />

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">Changed Lives</span>
            <h2>Stories of Transformation</h2>
            <p>Read the powerful stories of men whose lives have been transformed through faith and the ministry of Teen Challenge Armenia.</p>
          </div>

          <div className="testimonies-grid">
            {testimonies.map((t, i) => (
              <Link
                to={`/testimony/${t.slug}`}
                key={t.slug}
                className={`testimony-card fade-in delay-${i + 1}`}
                style={{ textDecoration: 'none' }}
              >
                <div className="testimony-card-img">
                  <img src={t.image} alt={t.name} loading="lazy" />
                </div>
                <div className="testimony-card-body">
                  <h3>{t.name}</h3>
                  <p>{t.excerpt}</p>
                  <span className="read-more">Read story →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonies;
